import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import { Box } from 'components/_new/layout'
import { Price, OldAndNewPrices } from 'components/_new/ui'
import Text from 'components/_new/typography/Text/Text'

import messages from './messages'
import s from './GiftSetPrice.scss'


const GiftSetPrice = ({ className, priceWithDiscount, price }) => (
  <div className={cx(s.priceSection, className)}>
    <Box mr={4} noWrapper>
      <Text message={messages.price} tag="span" />
    </Box>
    {
      priceWithDiscount ? (
        <OldAndNewPrices oldPrice={price} newPrice={priceWithDiscount} isCents />
      ) : (
        <Price value={price} isCents />
      )
    }
  </div>
)

GiftSetPrice.propTypes = {
  priceWithDiscount: PropTypes.number,
  price: PropTypes.number.isRequired,
}

export default GiftSetPrice
